<template>
<div class="row data-row"
     :class="{'data-row-has-change': dailyDiff.hasChange}"
     :style="{height: rowHeight() + 'px'}">
    <div class="col-3 data-col"><span class="wrap-text">{{ dailyDiff.dateString }}</span></div>
    <div class="col-3 data-col"><span class="wrap-text">{{ oldAmountStr() }}</span></div>
    <div class="col-3 data-col"><span class="wrap-text">{{ fixedStr(dailyDiff.amount) }}</span></div>
    <div class="col-3 data-col">
        <div class="state-text-wrap">
            <p v-if="dailyDiff.isAdded" class="state-text added">追加あり</p>
            <p v-if="dailyDiff.isDeleted" class="state-text deleted">削除あり</p>
            <p v-if="dailyDiff.isChanged" class="state-text changed">変更あり</p>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {DailyDiff} from "@/data-models/daily-diff";

export default defineComponent({
    name: "DailyDiffRow",
    props: {
        dailyDiff: {
            type: Object as PropType<DailyDiff>,
            required: true
        }
    },
    setup(props) {

        const fixedStr = (num: number): string => {
            const decimal = props.dailyDiff.hasChange ? 5 : 3
            return num.toFixed(decimal)
        }

        const oldAmountStr = () => {
            return props.dailyDiff.hasChange
                ? fixedStr(props.dailyDiff.oldAmount)
                : "--"
        }

        const rowHeight = (): number => {
            let h = 0
            if (props.dailyDiff.isAdded) {
                h += 30
            }

            if (props.dailyDiff.isDeleted) {
                h += 30
            }

            if (props.dailyDiff.isChanged) {
                h += 30
            }

            return h > 40 ? h : 40
        }

        return {
            fixedStr,
            oldAmountStr,
            rowHeight,
        }
    }
})
</script>

<style scoped lang="scss">

.data-row {
    min-height: 40px;
    border-bottom: solid 1px lightgray;
    .data-col {
        border-left: solid 1px lightgray;

        &:last-child {
            border-right: solid 1px lightgray;
        }
    }

    &-has-change {
        border: solid 1px orange;
        background-color: #FFE2BB;
    }
}

.state-text-wrap {

    //background-color: blue;
    position: absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    width:100%;

    .state-text {
        margin: 5px;
        height: 20px;
    }

    .added {
        color: #006839;
        background-color: #6affbb;
    }

    .deleted {
        color: red;
        background-color: #FFBBBB;
    }

    .changed {
        color: darkgoldenrod;
        background-color: #ffc270;
    }
}

</style>